'use client';

import { useCart } from '@qlevr/shared/providers';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { useTranslations } from 'use-intl';
import { ReactComponent as Aeromoov } from '../../icons/brands/aeromoov.svg';
import { ReactComponent as Aerosleep } from '../../icons/brands/aerosleep.svg';
import { ReactComponent as Puckababy } from '../../icons/brands/puckababy.svg';

export interface BrandNavigationInterface {
  brandName: string;
}

export function BrandNavigation({ brandName }: BrandNavigationInterface) {
  const { cartIdCookie } = useCart();

  const t = useTranslations();
  const { locale } = useParams<{ locale: string }>();

  // Hardcoded for now, will be dynamic in the future
  if (locale === 'es-es' || locale === 'it-it') {
    return null;
  }

  function addCartId(url: string) {
    const urlParams = new URLSearchParams();
    urlParams.append('cartId', cartIdCookie || '');

    return `${url}?${urlParams.toString()}`;
  }

  const brands = [
    { name: 'AeroMoov', Icon: Aeromoov, url: `${process.env.NEXT_PUBLIC_AEROMOOV_BASE_URL}/${locale}`, height: 'h-2' },
    {
      name: 'AeroSleep',
      Icon: Aerosleep,
      url: `${process.env.NEXT_PUBLIC_AEROSLEEP_BASE_URL}/${locale}`,
      height: 'h-2',
    },
    {
      name: 'Puckababy',
      Icon: Puckababy,
      url: `${process.env.NEXT_PUBLIC_PUCKABABY_BASE_URL}/${locale}`,
      height: 'h-3.5',
    },
  ];

  return (
    <nav className="relative after:absolute after:bottom-0 after:h-[1px] after:w-full after:border-b after:border-slate-300 after:bg-slate-300">
      <ul className="flex md:flex-row">
        {brands.map(({ name, Icon, url, height }) => (
          <li
            key={name}
            className={`group z-10 flex w-1/4 items-center justify-center border-b border-r md:w-auto ${name === brandName ? 'border-b-white' : 'border-b-slate-300'} border-r-slate-300 transition duration-500 hover:border-b-white`}
          >
            <Link className="items-center py-4 md:flex md:pl-4 md:pr-2" href={addCartId(url)}>
              <Icon
                className={`${height} ${name === brandName ? 'text-black' : 'text-slate-300'} transition-all duration-500 group-hover:text-black`}
              />
              <span className="hidden max-w-0 overflow-hidden whitespace-nowrap pl-2 text-xs font-normal transition-all duration-500 group-hover:max-w-full md:block">
                {t(`header.brandNavigation.taglines.${name}`)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default BrandNavigation;
